import { APP_ROUTES_LOGIN } from '@data'
import { queryClient } from '../store/provider/TanStackProvider'
import {
  AccepInviteProps,
  DeviceStorage,
  ForgotPasswordProps,
  LoginProps,
  PatientResetPasswordProps,
  ResetPasswordProps,
  VerifyVerificationProps
} from '../types/auth.types'
import { AsyncLocalStorage } from '../utils'
import { deleteAuthHeadersFromDeviceCookies } from '../utils/auth'
import AXIOS_INSTANCE from './axiosInstance'

export const Storage: DeviceStorage = AsyncLocalStorage

export const AuthApi = () => {
  const login = async (payload: LoginProps): Promise<any> => {
    try {
      const response = await AXIOS_INSTANCE.post('/auth/sign_in', payload)
      return response
    } catch (error: any) {
      return error?.response
    }
  }

  const acceptInvite = async (payload: AccepInviteProps): Promise<{ data: string }> => {
    try {
      const response = await AXIOS_INSTANCE.patch('/invitation', payload)
      return response
    } catch (error: any) {
      return error?.response
    }
  }

  const logout = async () => {
    try {
      // Save current URL before clearing storage (only if not already on login page)
      // if (typeof window !== 'undefined') {
      //   const currentPath = window.location.pathname + window.location.search
      //   if (
      //     currentPath !== APP_ROUTES_LOGIN &&
      //     !currentPath.startsWith('/forgot-password') &&
      //     !currentPath.startsWith('/reset-password')
      //   ) {
      //     sessionStorage.setItem('redirectAfterLogin', currentPath)
      //   }
      // }
      deleteAuthHeadersFromDeviceCookies()
      localStorage.clear()
      // Preserve redirectAfterLogin in sessionStorage
      // const redirectUrl = sessionStorage.getItem('redirectAfterLogin')
      sessionStorage.clear()
      // if (redirectUrl) {
      //   sessionStorage.setItem('redirectAfterLogin', redirectUrl)
      // }
      queryClient.clear()
      // Navigate to login using window object to ensure a full reload
      if (typeof window !== 'undefined') {
        window.location.replace(APP_ROUTES_LOGIN)
      }
      await AXIOS_INSTANCE.delete('/auth/sign_out')
    } catch (error) {
      console.log(error)
    }
  }

  const forgotPassword = async (payload: ForgotPasswordProps): Promise<any> => {
    try {
      const response = await AXIOS_INSTANCE.post('/auth/password', payload)
      return response
    } catch (error: any) {
      return error?.response
    }
  }

  const verifyVerification = async (payload: VerifyVerificationProps): Promise<any> => {
    try {
      const response = await AXIOS_INSTANCE.post('/patient-password/verify', payload)
      return response
    } catch (error: any) {
      return error?.response
    }
  }
  const resetPassword = async (payload: ResetPasswordProps): Promise<{ status: boolean; data: any }> => {
    try {
      const response = await AXIOS_INSTANCE.patch('/auth/password', payload)
      return { data: response, status: true }
    } catch (error: any) {
      return { data: error?.response, status: false }
    }
  }

  const patientResetPassword = async (payload: PatientResetPasswordProps): Promise<any> => {
    try {
      const response = await AXIOS_INSTANCE.patch('/patient-password/update', payload)
      return response
    } catch (error: any) {
      return error?.response
    }
  }

  const unlockAccount = async (unlockToken: string): Promise<{ status: boolean; data: any }> => {
    try {
      const response = await AXIOS_INSTANCE.get('/auth/unlock', { params: { unlock_token: unlockToken } })
      return { data: response, status: true }
    } catch (error: any) {
      return { data: error?.response, status: false }
    }
  }

  return {
    Storage,
    acceptInvite,
    forgotPassword,
    login,
    logout,
    resetPassword,
    unlockAccount,
    verifyVerification,
    patientResetPassword
  }
}

export default AuthApi
